import * as getters from './getters'
import { map, clamp } from '@/helpers/MathUtils'
import { findWhere } from '@/helpers/ArrayUtils'
import AnalyticsService from '@/services/AnalyticsService'

export const setState = (state, value) => {
  state.prev_state = state.state;
  state.state = value;
  AnalyticsService.sendEvent('QUESTION', 'set', 'state', value);
}

export const setTranscription = (state, value) => {
  state.transcription = value;
  AnalyticsService.sendEvent('GCP', 'response', 'transcription', value);
}

export const setTapHoldRatio = (state, value) => {
  state.tap_hold_ratio = value; 
} 

export const setTimerRatio = (state, value) => {
  state.timer_ratio = value; 
}

export const setResult = (state, value) => {

  let score = value.score;
  state.result.score = score; 
  state.result.magnitude = value.magnitude;

  AnalyticsService.sendEvent('GCP', 'response', 'sentiment_score',  state.result.score);
  AnalyticsService.sendEvent('GCP', 'response', 'sentiment_magnitude',  state.result.magnitude); 
 
  // index :: used to mapp facial assets
  let index = 0; 
  if (score === null) {
    index = 9; // error
  } else if (score < -0.8) { // Furious
    index = 0;
  } else if (score >= -0.8 && score < -0.6) {  // sad
    index = 1;
  } else if (score >= -0.6 && score < -0.4) {  // angry
    index = 2;
  } else if (score >= -0.4 && score < -0.1) {  // irritated
    index = 3;
  } else if (score >= -0.1 && score < 0.1) {  // confused
    index = 4;
  } else if (score >= 0.1 && score < 0.4) { // Mildly Amused
    index = 5;
  } else if (score >= 0.4 && score <= 0.6) { // Entertained
    index = 6;
  } else if (score >= 0.6 && score <= 0.8) { // Happy
    index = 7;
  } else if (score > 0.8 ) { // Ecstatic
    index = 8;
  }

 
  // percentage :: used in emotional meter
  let percentage = 0; 
  switch(state.targetIndex) {

    case state.GOALS.ANGRY:
        percentage = map(clamp(score, -1, 0), -1, 0, 100, 0 );
        break;

    case state.GOALS.SAD:
        if(score <= -0.7){
          percentage = map(clamp(score, -1, -0.7), -1, -0.7, 0, 100 );
        } else {
          percentage = map(clamp(score, -0.7, -0.4), -0.7, -0.4, 100, 0 );
        } 
        break; 

    case state.GOALS.CONFUSED:
        if(score <= 0){
          percentage = map(clamp(score, -1, 0), -1, 0, 0, 100 );
        } else {
          percentage = map(clamp(score, 0, 1), 0, 1, 100, 0 );
        } 
        break;

    case state.GOALS.HAPPY:
        percentage = map(clamp(score, 0, 1), 0, 1, 0, 100 );
        break; 
  }


  // set result 
  if(percentage >= 90){
    state.goal.complete = true;
  }

  AnalyticsService.sendEvent('QUESTION', 'change', 'goal_complete',  state.goal.complete); 

  // set bait copy
  switch(state.targetIndex) {

    case state.GOALS.ANGRY:
      if(state.goal.complete){
        state.result.bait = state.goal.congrats;
      } else {
        state.result.bait = state.goal.bait;
      }
      break;

    case state.GOALS.SAD:
      if(state.goal.complete){
        state.result.bait = state.goal.congrats;
      } else {
        state.result.bait = state.goal.bait;
      }
      break; 

    case state.GOALS.CONFUSED:
        if(state.goal.complete){
          state.result.bait = state.goal.congrats;
        } else {
          if(score <= 0){ 
            state.result.bait = state.goal.baitNeg;
          } else {
            state.result.bait = state.goal.baitPos;
          }
        }
        break;

    case state.GOALS.HAPPY:
      if(state.goal.complete){ 
        state.result.bait = state.goal.congrats;
      } else {
        state.result.bait = state.goal.bait;
      }
      break; 
  }


  let complete_goals = 0;
  for (var i = 0; i < state.collection.length; i++) {
    let completed = state.collection[i].complete;
    if(completed){
      complete_goals++;
    }
  }



  // reorder collection base on target Goal, move to start of array. 
  let tgGoal; 

  for (var i = 0; i < state.collection.length; i++) {
    let goal = state.collection[i]; 
    if(goal.id === state.targetIndex){
      tgGoal = goal;
    }
  }

  // reorder based on selected 
  let oldIndex = state.collection.indexOf(tgGoal) 
  state.collection.splice(oldIndex, 1);
  state.collection.unshift(tgGoal);




  if(complete_goals === state.collection.length){
    state.goals_completed = true;
  }
 
  state.result.percentage = percentage;
  state.result.index = index; 
 
  setState(state, state.STATES.COMPLETE);


  // console.log(' - - - - - - - - - ')
  // console.log(' - - - - > percentage ', percentage)
  // console.log(' - - - - > index ', index)
  // console.log(' - - - - > collection ', state.collection)
  // console.log(' - - - - > state ', state)
  // console.log(' - - - - > score ', score)
  // console.log(' - - - - - - - - - ')
}

export const setIntialShow = (state) => {
  state.initialShow = false;
}

export const setTapHoldCTA = (state, value) => {
  state.tap_hold_cta = value;
}

export const setFreq = (state, value) => {
  state.frequencyData = value;
}

export const setTargetIndex = (state, value) => {
  state.targetIndex = value;
  state.goal = findWhere( state.collection, {id: value}); 

  AnalyticsService.sendEvent('QUESTION', 'set', 'target_goal', state.goal.title ); 
}

export const setTapHoldValid = (state, value) => {
  state.tap_hold_cta_valid = value; 
} 